import axios from 'axios'
export function getPageList({page,size,env,name}) {
  const url = '/t/tplugin/page'
  const params = {page,size,env,name}
  return axios.get(url,{params}).then((res)=>res.data)
}
export function getAllPageList({env}) {
  const url = '/t/tplugin/list'
  const params = {env}
  return axios.get(url,{params}).then((res)=>res.data)
}

export function addPlugin({version,force,env,name,log,file,storageId}) {
  const url = '/t/tplugin/addPlugin'
  const data = {version,force,env,name,log,file,storageId}
  let formData = new FormData()
  for(let i in data){
    formData.append(i,data[i])
  }
  return axios.post(url,formData).then((res)=>res.data)
}


export function updatePlugin({version,force,env,name,log,file,id,storageId}) {
  const url = '/t/tplugin/updatePlugin'
  const data = {version,force,env,name,log,id,storageId}
  if(file) data.file = file
  let formData = new FormData()
  for(let i in data){
    formData.append(i,data[i])
  }
  return axios.post(url,formData).then((res)=>res.data)
}

export function deletePlugin({id}) {
  const url = '/t/tplugin/deletePlugin'
  const data = {id}
  let formData = new FormData()
  for(let i in data){
    formData.append(i,data[i])
  }
  return axios.post(url,formData).then((res)=>res.data)
}
export function findAppPlugins({proId,version}) {
  const url = '/t/appplugin/findAppPlugins.action'
  const params = {proId,version}
  return axios.get(url,{params}).then((res)=>res.data)
}

export function addAppPlugins({proId,proVersion,plugins}) {
  const url = '/t/appplugin/addAppPlugins'
  const data = {proId,proVersion,plugins}
  let formData = new FormData()
  for(let i in data){
    formData.append(i,data[i])
  }
  return axios.post(url,formData).then((res)=>res.data)
}

// app 版本提交
export function addAppVersionData(data){
  const url = '/appconfig/t/app/publish'
  let formData = new FormData()
  for(let i in data){
    formData.append(i,data[i])
  }
  return axios.post(url,formData).then((res)=>res.data)
}
